import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function About() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="pt-16" data-testid="about-page">
      <section className="relative py-28 overflow-hidden">
        <img src="https://images.unsplash.com/photo-1676452502636-2e527b03581d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-espresso/80" />
        <div className="relative max-w-3xl mx-auto px-5 text-center">
          <p className="overline">Our Story</p>
          <h1 className="font-serif text-4xl sm:text-6xl text-cream mt-3">Recovery, Refined.</h1>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-5 py-16 space-y-8 text-cream/80 leading-relaxed">
        <p className="text-xl font-light text-cream">We believe deep recovery shouldn't require a trip to a luxury resort — it should live in your home, your gym, your sanctuary.</p>
        <p>The Recovery Shops began with a simple frustration: buying a sauna or cold plunge online was confusing, impersonal and intimidating. Specs you couldn't decode, no guidance, and no one to talk to. We set out to fix that.</p>
        <p>Today we're an authorized dealer for the finest names in wellness — Harvia, Kohler, Dundalk LeisureCraft, HealthSmart and more — paired with a guided buying experience, AI matchmaking, and a team of real recovery specialists. Every order is backed by white glove delivery and lifetime support.</p>
        <p>From a first-time buyer's apartment sauna to a 10-person commercial installation, we treat every sanctuary with the same care. This is recovery, refined.</p>
        <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/10">
          {[["5,000+", "Sanctuaries delivered"], ["4.8★", "Average rating"], ["20+", "Premium brands"]].map(([n, l]) => (
            <div key={l} className="text-center"><p className="font-serif text-3xl text-gold">{n}</p><p className="text-cream/60 text-sm mt-1">{l}</p></div>
          ))}
        </div>
        <div className="text-center pt-6">
          <Link to="/quiz" className="inline-block bg-gold text-espresso px-8 py-3.5 font-medium hover:bg-amber transition-colors">Find Your Match</Link>
        </div>
      </section>
    </div>
  );
}
